export const findOptionSelected = (currentValue, event) => {
  return currentValue.find((currentValue) => currentValue.value === event.target.value.value);
};
